export const SIZES = ['3XS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL', '7XL'];
export const EU_PREFIX = 'EU ';
export const DROPDOWN_SCROLL_MIN_ITEMS = 5;
export const DROPDOWN_MIN_HEIGHT = 200;
export const FIELDS_WITH_PLACEHOLDERS = ['size', 'category-sort', 'years', 'months', 'days'];
